/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiActionType;
(function (ApiActionType) {
    ApiActionType["EMAIL_CONTACT"] = "EMAIL_CONTACT";
    ApiActionType["REDIRECT"] = "REDIRECT";
})(ApiActionType || (ApiActionType = {}));
export function ApiActionTypeFromJSON(json) {
    return ApiActionTypeFromJSONTyped(json, false);
}
export function ApiActionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiActionTypeToJSON(value) {
    return value;
}
